// extracted by mini-css-extract-plugin
export var recentProject = "recentProjects-module--recentProject--91458";
export var recentProjects = "recentProjects-module--recentProjects--febb5";